import React, { useContext, useEffect, useState } from "react";
import {
    Box,
    Typography,
    Avatar,
    Skeleton,
    Stack,
    IconButton,
    Grid,
    CardContent,
    Card,
    Modal,
} from "@mui/material";
import { ArrowForward, Mic, Search, Close as CloseIcon } from '@mui/icons-material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { RiHospitalLine } from 'react-icons/ri';
import { useNavigate } from "react-router-dom";
import { get, post } from "../../utility/fetchWeb";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import { useDrawer } from "../../contexts/DrawerContext";
import MapSelector from "../Layout/MapSelector";
import VoiceRecorder from '../inputs/VoiceRecorder';
import Greeting from "../Layout/Greeting";
import DoctorSearchBar from "../Layout/DoctorSearchBar";
import { UserContext } from '../../contexts/UserContext';
import Tooltip from '@mui/material/Tooltip';
import PromoBanner from "../Layout/PromoBanner";
import LaboratoryChatModal from "../modals/LaboratoryChatModal";
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import VideoCalling from '../Layout/VideoCalling';
import Pagination from "../Layout/Pagination";

export default function HospitalPage() {
    const [selectedCategory, setSelectedCategory] = useState("General");
    const navigate = useNavigate();
    const [data, setData] = React.useState([]);
    const [categories, setCategories] = React.useState([]);
    const [engagedDoctors, setEngagedDoctors] = React.useState([]);
    const [searchText, setSearchText] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [currentLocation, setCurrentLocation] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [isVoiceModalOpen, setIsVoiceModalOpen] = useState(false);
    const [isListening, setIsListening] = useState(false);
    const [recommendedHospitals, setRecommendedHospitals] = useState([]);
    const [showVoiceResults, setShowVoiceResults] = useState(false);
    const [targetedAds, setTargetedAds] = useState([]);
    const { profilePicture } = useContext(UserContext);

    const { toggleAdmissionDetailsDrawer, setComponent } = useDrawer();

    const [labServicesModalOpen, setLabServicesModalOpen] = useState(false);
    const [selectedHospital, setSelectedHospital] = useState(null);
    const [labServicesLoading, setLabServicesLoading] = useState(false);
    const [labServiceSearch, setLabServiceSearch] = useState('');
    const [isVoiceLabServiceModalOpen, setIsVoiceLabServiceModalOpen] = useState(false);
    const [labServices, setLabServices] = useState([]);
    const [filteredLabServices, setFilteredLabServices] = useState([]);

    const [isChatModalOpen, setIsChatModalOpen] = useState(false);
    const [selectedHospitalForChat, setSelectedHospitalForChat] = useState(null);

    const [showVideoChatModal, setShowVideoChatModal] = useState(false);
    const [startAudioOnly, setStartAudioOnly] = useState(false);
    const [appId, setAppId] = useState(process.env.REACT_APP_AGORA_KEY);
    const [channel, setChannel] = useState("call");
    const [token, setToken] = useState(null);
    const [uid, setUid] = useState(sessionStorage.getItem("userId") || "defaultUid");
    const [selectedHospitalForCall, setSelectedHospitalForCall] = useState(null);
    const [callId, setCallId] = useState(null); // Add callId state
    const query = new URLSearchParams(window.location.search);
    const chatId = query?.get("rrt") ? Number(query?.get("rrt")) : null;


    const getEngagedDoctors = async () => {
        try {
            const response = await get(`/Doctors/EngagedDoctors/${sessionStorage.getItem("userId")}`);
            console.log('Response:', response);
            setEngagedDoctors(response);
        } catch (error) {
            console.error("Error fetching doctors:", error);
        }
    }

    const handleToggle = () => {
        setComponent("chat");
    }

    const getHealthCareProvider = async (page = 1) => {
        setIsLoading(true);
        try {
            let response;
            response = await get(`/HealthCareProvider/list/HealthCareProviderCategory/${5}/true?pageNumber=${page}&pageSize=10`);
            console.log('Response:', response);
            setData(response.data.recordList);
            setFilteredData(response.data.recordList);
            setTotalPages(response?.data.metadata.totalPages || 1);
            setCurrentPage(response?.data?.metadata.page || 1);
            setIsLoading(false);
        } catch (error) {
            console.error('Error fetching doctors:', error);
            setIsLoading(false);
        }
    }

    const getSearchedHealthCareProvider = async (searchText, page = 1) => {
        setIsLoading(true);
        try {
            let response;

            response = await get(`/HealthCareProvider/filter-list/true/categoryType/Hospital/Name/${searchText}?pageNumber=${page}&pageSize=10`);
            console.log('Response:', response);
            setData(response?.data?.recordList);
            setFilteredData(response?.data?.recordList);
            setTotalPages(response?.data?.metadata.totalPages || 1);
            setCurrentPage(response?.data?.metadata.page || 1);
            setIsLoading(false);

        } catch (error) {
            console.error('Error fetching doctors:', error);
            setData([]);
            setFilteredData([]);
            setIsLoading(false);
        }
    }

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        if (e.target.value.length >= 2) {
            getSearchedHealthCareProvider(e.target.value, currentPage);
        } else if (e.target.value.length === 0) {
            getHealthCareProvider();
        }
    };

    const handleChange = (event) => {
        const { value } = event.target;
        setSearchText(value);
        if (value.length >= 2) {
            getSearchedHealthCareProvider(value, currentPage);
        } else if (value.length === 0) {
            getHealthCareProvider();
        }
    }

    const getcategories = async () => {
        try {
            const response = await get('/categories');
            console.log(response);
            setCategories(response.data);
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    }

    const handleLocationSelect = (location, address) => {
        console.log("Selected Location:", location);
        console.log("Selected Address:", address);
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        getHealthCareProvider();
        getEngagedDoctors();
        getTargetedAds();

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    setCurrentLocation({ lat: latitude, lng: longitude });
                },
                (error) => {
                    console.error("Error getting current location:", error);
                }
            );
        }
    }, [])

    useEffect(() => {
        if (searchQuery.length >= 3) {
            getSearchedHealthCareProvider(searchQuery, currentPage);
        } else if (searchQuery.length === 0) {
            getHealthCareProvider(currentPage);
        }
    }, [searchQuery]);

    const handleMicClick = () => {
        setIsVoiceModalOpen(true);
    };

    const handleTranscript = async (transcript) => {
        setIsLoading(true);
        setSearchQuery(transcript);
        setIsListening(true);
        try {
            setShowVoiceResults(true);
            setIsVoiceModalOpen(false);
        } catch (error) {
            console.error('Error fetching hospitals:', error);
        } finally {
            setIsListening(false);
            setIsLoading(false);
        }
    };

    const getTargetedAds = async () => {
        try {
            const userId = sessionStorage.getItem('userId');
            const pageName = 'Hospital Search';
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/connecthealthadmin/api/ad/find-ad?Id=${userId}&page=${pageName}`);

            if (response.ok) {
                const data = await response.json();
                const transformedAds = data.map(ad => ({
                    id: ad.id,
                    imageUrl: ad.bannerImageUrl,
                    title: ad.title,
                    subtitle: ad.description,
                    redirectUrl: ad.redirectUrl,
                    status: 1,
                    isTargeted: true
                }));
                setTargetedAds(transformedAds);
            }
        } catch (error) {
            console.error('Error fetching targeted ads:', error);
            setTargetedAds([]);
        }
    };

    const handleCartClick = (e, hospital) => {
        e.stopPropagation();
        setSelectedHospital(hospital);
        setLabServicesModalOpen(true);
        fetchLabServices(hospital.id);
    };

    const handleCloseLabServicesModal = () => {
        setLabServicesModalOpen(false);
        setSelectedHospital(null);
        setLabServices([]);
        setFilteredLabServices([]);
        setLabServiceSearch('');
    };

    const fetchLabServices = async (hospitalId) => {
        setLabServicesLoading(true);
        try {
            const response = await get(`/internallabservice/list/${hospitalId}/1/50/by-health-care-provider`);
            console.log('Lab Services Response:', response);

            const services = response?.data.recordList || response?.data || [];
            setLabServices(services);
            setFilteredLabServices(services);
        } catch (error) {
            console.error('Error fetching lab services:', error);
            setLabServices([]);
            setFilteredLabServices([]);
        } finally {
            setLabServicesLoading(false);
        }
    };

    const handleLabServiceSearchChange = (e) => {
        const searchValue = e.target.value;
        setLabServiceSearch(searchValue);

        if (searchValue.trim() === '') {
            fetchLabServices(selectedHospital.id);
        } else if (searchValue.length >= 2) {
            fetchFilteredLabServices(selectedHospital.id, searchValue);
        }
    };

    const fetchFilteredLabServices = async (hospitalId, searchQuery) => {
        setLabServicesLoading(true);
        try {
            const response = await get(`/internallabservice/filter-list/${hospitalId}/testName/${searchQuery}/1/50/by-health-care-provider`);
            console.log('Filtered Lab Services Response:', response);

            const services = response?.data.recordList || response?.data || [];
            setLabServices(services);
            setFilteredLabServices(services);
        } catch (error) {
            console.error('Error fetching filtered lab services:', error);
            const filtered = labServices.filter(service =>
                service.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                service.description?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                service.testName?.toLowerCase().includes(searchQuery.toLowerCase())
            );
            setFilteredLabServices(filtered);
        } finally {
            setLabServicesLoading(false);
        }
    };

    const handleLabServiceVoiceSearch = () => {
        setIsVoiceLabServiceModalOpen(true);
    };

    const handleLabServiceVoiceTranscript = async (transcript) => {
        setLabServiceSearch(transcript);

        if (transcript.trim().length >= 2) {
            await fetchFilteredLabServices(selectedHospital.id, transcript);
        }

        setIsVoiceLabServiceModalOpen(false);
    };

    const handleMessageClick = (e, hospital) => {
        e.stopPropagation(); // Prevent the card's onClick from firing
        setSelectedHospitalForChat(hospital);
        setIsChatModalOpen(true);
    };
    const notifyCaller = async (chann, id) => {
        try {
            const res = await post(`/Posts/notify-call`, {
                receiverId: id,
                channelName: chann,
                callerId: Number(sessionStorage.getItem("userId")),
                callerName: sessionStorage.getItem("name"),
                userType: 2 // for practitioner 1 for patient
            });
            console.log(res)
            if (res?.data) {
                console.log("Caller notified successfully");
            } else {
                console.error("Failed to notify caller:", res);
            }
        } catch (error) {
            console.error("Error notifying caller:", error);
        }
    }

    const getAgoraDetails = async (receiverId) => {
        try {
            const res = await get(`/posts/generate-new-token?channelName=${`connecthealthpro_videocall-${uid}&${receiverId}`}&uid=${uid}`);
            if (res && res.token) {
                setToken(res.token);
                setUid(Number(res.uid) || uid);
                setAppId(res.appId || process.env.REACT_APP_AGORA_KEY);
                setChannel(res.channelName || "call");
                return true;
            }
            return false;
        } catch (error) {
            console.error("Error fetching Agora token:", error);
            return false;
        }
    };

    const handleVideoCall = async (e, hospital) => {
        e.stopPropagation();
        setSelectedHospitalForCall(hospital);
        const success = await getAgoraDetails(hospital.contactPersonId);
        if (success) {
            setStartAudioOnly(false);
            setCallId(Date.now()); // Generate unique callId
            setShowVideoChatModal(true);
            notifyCaller(`${`connecthealthpro_videocall-${uid}&${hospital.contactPersonId}`}`, hospital.contactPersonId);
        }
    };

    const handleAudioCall = async (e, hospital) => {
        e.stopPropagation();
        setSelectedHospitalForCall(hospital);
        const success = await getAgoraDetails(hospital.contactPersonId);
        if (success) {
            setStartAudioOnly(true);
            setCallId(Date.now()); // Generate unique callId
            setShowVideoChatModal(true);
            notifyCaller(`${`connecthealthpro_audiocall-${uid}&${hospital.contactPersonId}`}`, hospital.contactPersonId);
        }
    };

    const handleCloseVideoChat = () => {
        setShowVideoChatModal(false);
        setToken(null);
        setSelectedHospitalForCall(null);
        setCallId(null); // Reset callId
    };

    return (
        <div className="w-100 pharmacy-page">
            {/* Header */}
            <Greeting name={sessionStorage.getItem("name")} />

            {/* Search Bar Section */}
            <div className="search-section">
                <div className="search-bar">
                    <input
                        type="text"
                        placeholder="Search for hospitals..."
                        value={searchQuery}
                        onChange={handleSearchChange}
                    />
                    {(searchQuery) && (
                        <button
                            className="clear-button"
                            onClick={() => {
                                setSearchQuery('');
                            }}
                        >
                            ×
                        </button>
                    )}
                </div>
                <div className="filter-btn" onClick={handleMicClick}>
                    <Mic color='white' />
                </div>
            </div>

            {isVoiceModalOpen && (
                <VoiceRecorder
                    onTranscript={async (transcript) => {
                        if (transcript) {
                            await handleTranscript(transcript);
                            setShowVoiceResults(true);
                        }
                        setIsVoiceModalOpen(false);
                        setIsListening(false);
                    }}
                    provider="Hospital"
                />
            )}

            {/* Add PromoBanner after search section */}
            {targetedAds.length > 0 && (
                <Box sx={{ mb: 3 }}>
                    <PromoBanner ads={targetedAds} />
                </Box>
            )}

            {isLoading ? (
                <div className="pharmacy-list">
                    {[...Array(6)].map((_, index) => (
                        <div key={index} className="pharmacy-card">
                            <Skeleton variant="circular" width={56} height={56} />
                            <div className="pharmacy-info">
                                <Skeleton variant="text" width="60%" height={20} />
                                <Skeleton variant="text" width="80%" height={24} />
                                <Skeleton variant="text" width="90%" height={16} />
                            </div>
                           
                            <Stack direction="row" spacing={1}>
                                <Skeleton variant="circular" width={40} height={40} />
                                <Skeleton variant="circular" width={40} height={40} />
                                <Skeleton variant="circular" width={40} height={40} />
                            </Stack>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="pharmacy-list">
                    {data?.length > 0 ? (
                        <>
                            {data?.map((hospital) => (
                                <div key={hospital.id} className="pharmacy-card" onClick={() => navigate(`/profile?cat=caregiverHos&id=${hospital?.id}`, { state: { providerData: hospital } })}>
                                    <div className="pharmacy-icon">
                                        {hospital?.logoPath ? (
                                            <img
                                                src={hospital.logoPath.startsWith('http')
                                                    ? hospital.logoPath
                                                    : `${process.env.REACT_APP_MEDIA_URL}${hospital.logoPath}`
                                                }
                                                alt="Hospital Logo"
                                                style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '12px' }}
                                                onError={(e) => {
                                                    const target = e.target;
                                                    if (target) {
                                                        target.style.display = 'none';
                                                        const parent = target.parentElement;
                                                        if (parent) {
                                                            const icon = document.createElement('div');
                                                            icon.innerHTML = '<RiHospitalLine style={{ fontSize: "24px", color: "white" }} />';
                                                            parent.appendChild(icon);
                                                        }
                                                    }
                                                }}
                                            />
                                        ) : <RiHospitalLine style={{ fontSize: '24px', color: 'white' }} />}
                                    </div>

                                    <div className="pharmacy-info">
                                        <div className="pharmacy-type">{hospital.healthCareProviderCategory?.name || 'Hospital'}</div>
                                        <h4 className="pharmacy-name">
                                            {hospital?.name}
                                        </h4>
                                        <p className="pharmacy-address">
                                            {hospital?.location || 'No location provided'}
                                        </p>
                                    </div>

                                   

                                    <Stack direction="row" spacing={1}>
                                        <Tooltip title="Message Hospital" arrow>
                                            <IconButton size="medium" color="primary" onClick={(e) => handleMessageClick(e, hospital)}>
                                                <ChatBubbleOutlineIcon fontSize="medium" />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Video Call" arrow>
                                            <IconButton size="medium" color="primary" onClick={(e) => handleVideoCall(e, hospital)}>
                                                <VideocamOutlinedIcon fontSize="medium" />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Audio Call" arrow>
                                            <IconButton size="medium" color="primary" onClick={(e) => handleAudioCall(e, hospital)}>
                                                <PhoneOutlinedIcon fontSize="medium" />
                                            </IconButton>
                                        </Tooltip>
                                    </Stack>
                                </div>
                            ))}
                        </>
                    ) : (
                        <Box sx={{ textAlign: "center", mt: 4 }}>
                            <Typography variant="h6" color="text.secondary">
                                We couldn't find any hospital matching your search.
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                You can browse through the available hospitals, search by name, or try a different location.
                            </Typography>
                        </Box>
                    )}

                    < Modal
                        open={labServicesModalOpen}
                        onClose={handleCloseLabServicesModal}
                        aria-labelledby="lab-services-modal-title"
                        aria-describedby="lab-services-modal-description"
                        sx={{
                            '& .MuiBackdrop-root': { backgroundColor: 'rgba(0,0,0,0.5)' }
                        }}
                    >
                        <Box sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: '50vw',
                            maxWidth: '1200px',
                            bgcolor: 'background.paper',
                            borderRadius: 3,
                            boxShadow: 24,
                            p: 4,
                            height: '80vh',
                            overflowY: 'auto',
                            '::-webkit-scrollbar': { display: 'none' },
                            scrollbarWidth: 'none'
                        }}>
                            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
                                <Typography id="lab-services-modal-title" variant="h6" component="h2">
                                    {selectedHospital?.name} - Available Lab Services
                                </Typography>
                                <IconButton onClick={handleCloseLabServicesModal}>
                                    <CloseIcon />
                                </IconButton>
                            </Stack>

                            <Box display="flex" gap={1} mb={2}>
                                <input
                                    type="text"
                                    placeholder="Search for lab services..."
                                    value={labServiceSearch}
                                    onChange={handleLabServiceSearchChange}
                                    style={{
                                        flex: 1,
                                        padding: '8px 12px',
                                        borderRadius: '8px',
                                        border: '1px solid #e0e0e0',
                                        fontSize: '15px'
                                    }}
                                />
                                <IconButton onClick={handleLabServiceVoiceSearch} color="primary">
                                    <Mic />
                                </IconButton>
                            </Box>

                            {labServicesLoading ? (
                                <Stack gap={2}>
                                    {[...Array(5)].map((_, idx) => (
                                        <Skeleton key={idx} variant="rectangular" height={48} />
                                    ))}
                                </Stack>
                            ) : (
                                <Stack gap={2}>
                                    {filteredLabServices.length === 0 ? (
                                        <Typography color="text.secondary">
                                            No lab services found.
                                        </Typography>
                                    ) : (
                                        filteredLabServices.map((service) => (
                                            <Box key={service.id} sx={{
                                                p: 2,
                                                borderRadius: 1,
                                                bgcolor: '#f8f9fa',
                                                boxShadow: 1,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: 0.5,
                                                cursor: 'pointer',
                                                '&:hover': { backgroundColor: '#e9ecef' }
                                            }}>
                                                <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                                                    {service.testName || service.name || service.serviceName}
                                                </Typography>
                                                {service.description && (
                                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                                                        {service.description}
                                                    </Typography>
                                                )}
                                                <Typography variant="body2" color="primary" sx={{ fontWeight: 600 }}>
                                                    ₦{service.price || service.cost || service.amount || 'Price not available'}
                                                </Typography>
                                            </Box>
                                        ))
                                    )}
                                </Stack>
                            )}
                        </Box>
                    </Modal>
                </div>
            )
            }

            {
                !isLoading && (
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={getHealthCareProvider}
                    />
                )
            }

            <LaboratoryChatModal
                open={isChatModalOpen}
                handleClose={() => {
                    setIsChatModalOpen(false);
                    setSelectedHospitalForChat(null);
                }}
                selectedLab={selectedHospitalForChat}
            />

            {
                showVideoChatModal && selectedHospitalForCall && (
                    <VideoCalling
                        appId={appId}
                        channel={channel}
                        token={token}
                        uid={uid}
                        callId={callId} // Pass callId
                        open={showVideoChatModal}
                        onClose={handleCloseVideoChat}
                        startWithVideoOff={startAudioOnly}
                        isAudio={startAudioOnly}
                    />
                )
            }

            <style jsx>{`
                .pharmacy-page {
                    padding: 24px;
                    margin: 0 auto;
                }

                .search-section {
                    display: flex;
                    gap: 12px;
                    margin: 24px 0;
                    align-items: center;
                }

                .search-bar {
                    flex: 1;
                    position: relative;
                    display: flex;
                    align-items: center;
                    background: #f8f9fa;
                    border-radius: 12px;
                    padding: 0 16px;
                    border: 1px solid #e9ecef;
                }

                .search-icon {
                    color: #6c757d;
                    margin-right: 12px;
                }

                .search-bar input {
                    flex: 1;
                    border: none;
                    background: transparent;
                    padding: 16px 0;
                    font-size: 16px;
                    outline: none;
                }

                .search-bar input::placeholder {

               
                    color: #6c757d;
                }

               

                .filter-btn:hover {
                    transform: scale(1.05);
                }

                .pharmacy-list {
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                }

                .pharmacy-card {
                    display: flex;
                    align-items: center;
                    padding: 20px;
                    background: white;
                    border-radius: 12px;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                    cursor: pointer;
                    transition: transform 0.2s, box-shadow 0.2s;
                    gap: 16px;
                }

                .pharmacy-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
                }

                .pharmacy-icon {
                    width: 56px;
                    height: 56px;
                    background: linear-gradient(135deg, #6f42c1, #e83e8c);
                    border-radius: 12px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    font-size: 24px;
                    flex-shrink: 0;
                }

                .pharmacy-info {
                    flex: 1;
                    min-width: 0;
                }

                .pharmacy-type {
                    color: #6c757d;
                    font-size: 12px;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                    margin-bottom: 4px;
                }

                .pharmacy-name {
                    font-size: 18px;
                    font-weight: 600;
                    color: #212529;
                    margin: 0 0 8px 0;
                }

                .pharmacy-address {
                    color: #6c757d;
                    font-size: 14px;
                    margin: 0;
                }

                .doctor-info {
                    flex: 1;
                    min-width: 0;
                    text-align: right;
                }

                .doctor-name {
                    font-size: 14px;
                    font-weight: 600;
                    color: #212529;
                    margin: 0 0 4px 0;
                }

                .doctor-role {
                    color: #6c757d;
                    font-size: 12px;
                    margin: 0;
                }
            `}</style>
        </div >
    );
}
